// src/components/SectionHeading.js
import styled from 'styled-components';
import { colors, fonts, fontSizes, fontWeights, space } from '../styles/tokens';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(p) => (p.$center ? 'center' : 'flex-start')};
  text-align: ${(p) => (p.$center ? 'center' : 'left')};
  gap: ${space[1]};
  margin-bottom: ${space[5]};
`;

const Prefix = styled.span`
  font-family: ${fonts.mono};
  font-size: ${fontSizes.xs};
  font-weight: ${fontWeights.regular};
  color: ${colors.accent};
  letter-spacing: 0.05em;
`;

const Title = styled.h2`
  font-family: ${fonts.sans};
  font-size: ${(p) => (p.$size === 'xl' ? fontSizes['2xl'] : fontSizes.xl)};
  font-weight: ${fontWeights.bold};
  color: ${colors.text};
  letter-spacing: -0.02em;
  line-height: 1.1;
`;

export function SectionHeading({ prefix, children, id, center = false, size }) {
  return (
    <Wrap $center={center}>
      {prefix && <Prefix aria-hidden="true">{`// ${prefix}`}</Prefix>}
      <Title id={id} $size={size}>{children}</Title>
    </Wrap>
  );
}
